<template>
  <div>
    <div class="shop min-container" v-if="step === 1">
      <div class="container shop_bg">
        <div class="container-con shop_form">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-position="top"
          >
            <div style="position: relative; min-height: 330px">
              <el-form-item
                label="KKTeenpatti User ID"
                prop="note"
                :error="userIdError"
              >
                <el-col :span="10">
                  <el-input
                    @click.native="showUserTip = false"
                    @input="inputUid"
                    placeholder="Please enter your user ID"
                    v-model.trim="ruleForm.note"
                  ></el-input>
                  <div style="margin-top: 20px" v-show="recaptchaStatus">
                    <vue-recaptcha
                      ref="recaptcha"
                      @verify="onDataCallback"
                      @expired="onExpiredCallback"
                      sitekey="6LfYRxcmAAAAAPiG4Nmkx2cC27Gkc3XFrpy0H0tu"
                    >
                    </vue-recaptcha>
                  </div>
                  <p v-show="showUserTip" class="show_user_tip">
                    Your user ID lies in the middle of the PROFILE tab in the
                    App.
                  </p>
                </el-col>
              </el-form-item>

              <!-- nickname confirm -->
              <el-form-item
                prop="nicknameConfirm"
                style="
                  margin-top: 10px;
                  position: relative;
                  left: 0px;
                  margin-bottom: 10px;
                  bottom: 15px;
                "
              >
                <el-checkbox-group
                  v-if="showConfirmNickname"
                  v-model="ruleForm.nicknameConfirm"
                >
                  <el-checkbox
                    size="medium"
                    name="type"
                    style="margin-top: 20px"
                  >
                    Please confirm the nickname:
                    <span style="color: #e77900">{{ nickname }}</span>
                    <img
                      style="
                        height: 40px;
                        margin: -13px 5px;
                        border-radius: 40px;
                      "
                      :src="headImgURL"
                    />
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <!-- email verification -->
              <el-form-item prop="email">
                <el-row type="flex" align="middle">
                  <el-col :span="10" style="margin-right: 20px">
                    <el-input
                      placeholder="Please enter your email"
                      v-model.trim="ruleForm.email"
                      :disabled="emailDisabled"
                    ></el-input>
                    <p
                      v-show="tipsSuccessEmail"
                      style="
                        color: #e77900;
                        font-size: 16px;
                        position: absolute;
                        left: 0px;
                        top: 100%;
                      "
                    >
                      This email has been verified
                    </p>
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="submit"
                      id="getCodebtnID"
                      v-if="isShowCode"
                      style="
                        margin-top: 0px;
                        background-color: #ffde00;
                        border-color: transparent;
                        color: #601b00;
                      "
                      @click="sendCode"
                      :disabled="getCodeBtnLock"
                      >Get a Code{{
                        countDown > 0 ? " (" + countDown + "s)" : ""
                      }}
                    </el-button>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item
                prop="code"
                v-if="isShowCode"
                :error="tipsCodeError"
              >
                <el-col style="width: 300px">
                  <el-input
                    placeholder="Please enter your code"
                    v-model="ruleForm.code"
                  ></el-input>
                </el-col>
              </el-form-item>
            </div>
            <el-form-item class="delivery" prop="type">
              <template slot="label">
                Delivery
                <el-tooltip placement="right">
                  <div slot="content" class="tips_content" style="width: 460px">
                    <p style="font-size: 14px; line-height: 22px">
                      1、If you have any questions during the purchase process,
                      please contact
                      <a
                        style="color: #ffde00"
                        href="mailto:info@mail.mvpstore.net"
                        >info@mail.mvpstore.net</a
                      >
                    </p>
                    <p style="font-size: 14px; line-height: 22px">
                      2、After successful purchase, gold coins will be sent to
                      your in-app mailbox automatically.
                    </p>
                  </div>
                  <img class="tips_img" src="/pc/static/img/shop/tips.png" />
                </el-tooltip>
              </template>
              <el-row class="money_list">
                <el-col
                  style="width: 265px"
                  :key="index"
                  v-for="(dia, index) in diamonds"
                >
                  <div class="poker-item">
                    <span class="dollar">$</span>
                    <h3 :class="{ hot_title: dia.hot }">{{ dia.price }}</h3>
                    <div
                      :class="phase == dia.phase ? `active_${dia.phase}` : ''"
                      @click="phase = dia.phase"
                      class="diamond"
                    >
                      <img src="/pc/static/img/shop/light_effect.png" />
                      <p>
                        {{ dia.diamond }}
                      </p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
            <div class="bottom">
              <el-form-item prop="agreement">
                <el-checkbox-group v-model="ruleForm.agreement">
                  <el-checkbox size="medium" name="type">
                    Please read
                    <a target="_blank" href="/legal/1">Privacy Policy</a> and
                    <a target="_blank" href="/legal/2"> Terms & Conditions </a>
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="submit"
                  @click="submitForm('ruleForm')"
                  style="
                    display: flex;
                    justify-content: center;
                    padding-top: 10px;
                  "
                >
                  <!-- <img src="/pc/static/img/shop/continue_01.png" /> -->
                  Continue
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <template v-else>
      <payment :query="query" :limitNum="limitNum" @return="step = 1"></payment>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import payment from '@/views/shop/payment.vue'
import VueRecaptcha from 'vue-recaptcha'

export default {
  data () {
    return {
      recaptchaStatus: true,
      googleRecaptcha: null,
      showUserTip: true,
      emailDisabled: true,
      tipsSuccessEmail: false,
      showConfirmNickname: false,
      isShowCode: false,
      tipsCodeError: '',
      userIdError: '',
      countDown: 0,
      getCodeBtnLock: false,
      nickname: '',
      headImgURL: '',
      submitting: false,
      limitNum: {},
      ruleForm: {
        userIdEmail: '',
        email: '',
        note: '',
        code: '',
        agreement: [],
        nicknameConfirm: []
      },
      rules: {
        note: [
          {
            validator: this.debounce(this.checkInfo, 600),
            trigger: 'change'
          }
        ],
        email: [
          {
            validator: this.checkEmail,
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: 'Code cannot be left empty',
            trigger: 'change'
          }
        ],
        nicknameConfirm: [
          {
            required: true,
            message: 'Please confirm the nickname',
            trigger: 'change'
          }
        ],
        agreement: [
          {
            required: true,
            message: 'Please read Privacy Policy and Terms & Conditions',
            trigger: 'change'
          }
        ]
      },
      phase: 1,
      diamonds: [
        {
          phase: 1,
          diamond: '10 Cr',
          num: '100',
          price: '9.99'
        },
        // {
        //   phase: 2,
        //   diamond: '100 Cr',
        //   num: '1000',
        //   price: '99.99'
        // },
        {
          phase: 3,
          diamond: '500 Cr',
          num: '5000',
          price: '499.99'
        },
        {
          phase: 4,
          diamond: '1000 Cr',
          num: '10000',
          price: '999.99'
        },
        {
          phase: 5,
          diamond: '2500 Cr',
          num: '10000',
          price: '2500.00'
        }
      ],
      query: {},
      step: 1
    }
  },
  components: {
    payment,
    VueRecaptcha
  },
  methods: {
    initial () {
      // console.log('initial')
      this.$store.commit('changeTab', '/shop')
      // this.$refs.recaptcha.reset()
      this.submitting = false
      this.recaptchaStatus = true
      this.googleRecaptcha = null
      this.showUserTip = true
      this.emailDisabled = true
      this.tipsSuccessEmail = false
      this.isShowCode = false
      this.tipsCodeError = ''
      this.userIdError = ''
      this.countDown = 0
      this.getCodeBtnLock = false
      this.nickname = ''
      this.headImgURL = ''
      this.ruleForm.userIdEmail = ''
      this.ruleForm.email = ''
      // this.ruleForm.note = ''
      this.ruleForm.code = ''
      // this.ruleForm.agreement = []
      this.ruleForm.nicknameConfirm = []
    },
    debounce (func, wait) {
      let timer = null
      return (rule, value, callback) => {
        // let args = arguments

        if (timer) clearTimeout(timer)

        timer = setTimeout(() => {
          func.call(this, rule, value, callback)
        }, wait)
      }
    },
    checkInfo (rule, value, callback) {
      if (this.submitting === false) {
        this.ruleForm.email = ''
        this.showConfirmNickname = false
        let save = this.ruleForm.note
        this.$refs['ruleForm'].resetFields()
        this.ruleForm.note = save
        this.emailDisabled = true
        // this.ruleForm.nicknameConfirm = []
        if (value === '') {
          this.showConfirmNickname = false
          this.emailDisabled = true
          callback(new Error('The User ID can not be empty'))
        } else {
          // 判断是否google验证通过
          if (this.googleRecaptcha) {
            this.$refs.recaptcha.reset()
            this.googleRecaptcha = null
            this.recaptchaStatus = true
          }
          callback()
        }
      } else {
        callback()
      }
    },
    checkEmail (rule, value, callback) {
      this.tipsSuccessEmail = false
      const reg =
        /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
      if (!value) {
        return callback(new Error('Email address cannot be left empty'))
      } else if (this.ruleForm.userIdEmail !== this.ruleForm.email) {
        if (!reg.test(value)) {
          callback(new Error('Email is not valid'))
          this.isShowCode = false
        } else {
          this.isShowCode = true
          callback()
        }
      } else {
        this.isShowCode = false
        callback()
      }
    },
    submitForm (formName) {
      // this.step = 2
      // 设置正处于提交状态
      this.submitting = true
      this.$refs[formName].validate((valid) => {
        if (!this.isShowCode) {
          this.$refs[formName].clearValidate('code')
        }
        if (valid) {
          if (!this.isShowCode) {
            const { price, diamond, num } = this.diamonds.find(
              item => item.phase === this.phase
            )
            this.query = {
              note: this.ruleForm.note,
              email: this.ruleForm.email,
              ifEmail:
                this.ruleForm.userIdEmail === this.ruleForm.email ? 0 : 1,
              amount: price,
              diamond: diamond,
              num: num,
              headImgURL: this.headImgURL,
              nickname: this.nickname,
              goods_id: this.phase
            }
            this.step = 2
          } else {
            this.$axios.defaults.baseURL = process.env.VUE_APP_AXIOS
            let data = new FormData()
            data.append('uid', this.ruleForm.note)
            data.append('code', this.ruleForm.code)
            data.append('email', this.ruleForm.email)
            // data.append('goods_id', this.phase)
            this.$axios
              .post('/payment/verify-email', data)
              .then((res) => {
                let data = res.data
                if (data.code === 0) {
                  // if (data.data && data.data.type === 1) {
                  //   this.tipsCodeError = 'The code is invalid'
                  // } else {
                  // 跳到第二部的代码
                  const { price, diamond, num } = this.diamonds.find(
                    item => item.phase === this.phase
                  )
                  this.query = {
                    note: this.ruleForm.note,
                    email: this.ruleForm.email,
                    ifEmail:
                      this.ruleForm.userIdEmail === this.ruleForm.email ? 0 : 1,
                    amount: price,
                    diamond: diamond,
                    num: num,
                    headImgURL: this.headImgURL,
                    nickname: this.nickname,
                    goods_id: this.phase
                  }
                  this.step = 2
                  // }
                } else if (data.code === 2005) {
                  // code不正确
                  this.tipsCodeError = ''
                  this.$nextTick(() => {
                    this.tipsCodeError =
                      'The Verification Code you entered is incorrect'
                  })
                } else {
                  alert(data.msg)
                }
                this.submitting = false
              })
              .catch(() => {
                alert('network error')
              })
          }
        } else {
          console.log('before return')
          return false
        }
      })
    },
    onDataCallback (recaptcha) {
      // 设置googleRecaptcha，这样表示google验证通过了
      this.googleRecaptcha = recaptcha
      if (!this.ruleForm.note) {
        this.showUserTip = false
        this.userIdError = ''
        this.userIdError = 'User ID cannot be left empty'
        return false
      }
      // 请求接口获取用户信息
      this.$axios.defaults.baseURL = process.env.VUE_APP_AXIOS
      this.$axios
        .post('/payment/userInfo', {
          uid: this.ruleForm.note,
          recaptcha,
          from: 'mvp'
        })
        .then((res) => {
          // console.log(res)
          // 隐藏google验证组件
          this.recaptchaStatus = false
          let response = res.data
          if (response.code === 0) {
            this.showConfirmNickname = true
            this.nickname = response.data.nickname
            this.headImgURL = response.data.headimgurl
            this.emailDisabled = false
            // 判断是否有绑定邮箱
            if (response.data.payment_email) {
              this.ruleForm.userIdEmail = response.data.payment_email
              this.ruleForm.email = response.data.payment_email
              this.isShowCode = false
            }
          } else {
            console.log('callback')
            this.initial()
            this.userIdError = ''
            this.$nextTick(() => {
              switch (res.data.code) {
                case 2001:
                  this.userIdError = ''
                  this.userIdError = 'The ID you entered is incorrect'
                  break
                case -4:
                  this.userIdError = 'Payment is not available to this user'
                  break
                default:
                  this.userIdError = 'error' + res.data.code
                  break
              }
            })
            this.showUserTip = false
            this.$refs.recaptcha.reset()
          }
        })
        .catch(() => {
          alert('network error')
        })
    },
    onExpiredCallback () {},
    sendCode () {
      this.getCodeBtnLock = true
      this.$axios.defaults.baseURL = process.env.VUE_APP_AXIOS
      let data = new FormData()
      data.append('uid', this.ruleForm.note)
      data.append('email', this.ruleForm.email)
      data.append('from', 'mvp')
      this.$axios
        .post('/payment/emailCode', data)
        .then((res) => {
          let data = res.data
          if (data.code === 0 || data.code === 2004) {
            if (data.data && data.data.status === 1) {
              // 表示该邮箱已通过
              this.isShowCode = false // 隐藏code输入框
              this.tipsSuccessEmail = true // 提示
            } else {
              this.countDown = 300
              document.getElementById('getCodebtnID').style.opacity = 0.4
              let timer = setInterval(() => {
                if (this.countDown === 0) {
                  this.countDown = 0
                  this.getCodeBtnLock = false
                  clearInterval(timer)
                } else {
                  this.countDown = this.countDown - 1
                }
              }, 1000)
            }
          } else {
            alert('Email is not valid')
          }
        })
        .catch(() => {
          alert('network error')
        })
    },
    inputUid () {
      if (!this.recaptchaStatus) {
        this.recaptchaStatus = true
      }
    }
  },
  created () {
    console.log(this.$route.query)
    this.initial()
  },
  mounted () {
    // this.step = 2
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.show_user_tip {
  color: #e77900;
  font-size: 16px;
  position: absolute;
  left: 0px;
  top: 95%;
}

.shop_form {
  /deep/ .el-form {
    .el-form-item__label {
      font-size: 22px;
      color: #fff;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .el-input__inner {
      font-size: 18px;
      border-color: #aaaaaa;
    }

    .el-form-item__error {
      font-size: 14px;
      // padding-top: 8px;
      color: #ff3333;
    }

    .el-checkbox__label {
      font-size: 18px;
      vertical-align: middle;
      padding-left: 4px;
      color: #fff;
    }

    .el-checkbox__inner {
      width: 18px;
      height: 18px;
      border-color: #aaaaaa;
    }

    .el-checkbox__inner::after {
      left: 6px;
      top: 3px;
    }

    .el-checkbox__inner::after {
      border-width: 2px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #e77900;
    }
  }
}

.shop {
  width: 100%;
  height: 1100px;
  background-color: #5a0814;
  background-image: url("/pc/static/img/shop/shop_bg01.jpg");
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center top;
}
.el-form {
  padding: 20px 0px;
  .el-checkbox-group {
    line-height: 25px;
    a {
      color: #089036;
      box-shadow: 0 1px;
    }
    .nickname-error {
      font-size: 14px;
      color: #ff0000;
    }
  }
  .el-form-item {
    margin-top: 28px;
    margin-bottom: 35px;
    .tips_img {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }
  }
  .delivery {
    // display: block;
    margin: 50px 0px 0px 0px;
    top: 35%;
    .tips_img {
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }
    .money_list {
      margin: 70px 0px 0px 75px;
      .el-col{
        .poker-item{
            .dollar {
              position: absolute;
              font-size: 35px;
            }
          }
        &:nth-child(1){
        .poker-item{
            .dollar {
              top: 12px;
              left: 30px;
            }
          }
        }
        &:nth-child(2){
        .poker-item{
            .dollar {
              top: 12px;
              left: 4px;
            }
          }
        }
        &:nth-child(3){
        .poker-item{
            .dollar {
              top: 10px;
              left: 5px;
            }
          }
        }
        &:nth-child(4){
        .poker-item{
            .dollar {
              top: 10px;
              left: -9px;
            }
          }
        }
      }
      .poker-item {
        position: relative;
        width: 200px;
        height: 140px;
        margin-top: 70px;
        display: inline-block;
        text-align: center;
        margin-bottom: 30px;
        h3 {
          font-size: 50px;
          margin: 20px 0px 22px 5px;
          font-weight: 700;
          color: #ffffff;
        }

        p {
          font-size: 28px;
          margin-top: 5px;
        }
        .diamond {
          position: relative;
          width: 180px;
          height: 140px;
          display: inline-block;
          text-align: center;
          cursor: pointer;
          margin-right: 20px;
          background-image: url(/pc/static/img/shop/coin.png);
          background-size: 100% auto;
          background-repeat: no-repeat;
          &:hover {
            background-image: url(/pc/static/img/shop/coin_active.png);
          }
          p {
            line-height: 42px;
            color: #642104;
            font-weight: 500;
          }
          img {
            display: none;
          }
        }
        .diamond.active_5 {
          background-image: url(/pc/static/img/shop/coin_active.png);
          p {
            color: #642104;
          }
          img {
            display: inline-block;
            position: absolute;
            bottom: 260px;
            right: -10px;
            width: 270px;
            height: 140px;
          }
        }
        .diamond.active_4 {
          background-image: url(/pc/static/img/shop/coin_active.png);
          p {
            color: #642104;
          }
          img {
            display: inline-block;
            position: absolute;
            bottom: 260px;
            left: -50px;
            width: 270px;
            height: 140px;
          }
        }
        .diamond.active_3 {
          background-image: url(/pc/static/img/shop/coin_active.png);
          p {
            color: #642104;
          }
          img {
            display: inline-block;
            position: absolute;
            bottom: 260px;
            left: -20px;
            width: 250px;
            height: 140px;
          }
        }
        .diamond.active_1 {
          background-image: url(/pc/static/img/shop/coin_active.png);
          p {
            color: #642104;
          }
          img {
            display: inline-block;
            position: absolute;
            bottom: 260px;
            left: 10px;
            width: 230px;
            height: 140px;
          }
        }
      }
    }
  }
  .bottom {
    // position: sticky;
    bottom: -15%;
    margin: 70px 0px 0px 0px;
    .submit {
      width: 190px;
      height: 63px;
      font-size: 24px;
      color: #601b00;
      padding: 0px 0px;
      border-color: transparent;
      background-color: transparent;
      margin-top: 5px;
      background-image: url(/pc/static/img/shop/continue_01.png);
      background-size: 100% auto;
      background-repeat: no-repeat;
      p {
        position: absolute;
        bottom: 30px;
        left: 43px;
        font-weight: 700;
      }
      &:hover {
        background-image: url(/pc/static/img/shop/continue_02.png);
      }
    }
  }
}
</style>
